import axiosService from 'services/axios.service';

export const getDiscount = async (param: any) => {
    try {
        const response = await axiosService.get(`/v1/admin/discounts?type=${param}`);
        return response?.data.data;
    } catch (error) {
        console.log(error);
    }
};
